// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataLayerPush(data: any) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function gtag(...args: unknown[]) {
  dataLayerPush(args);
}
